import React from 'react';

export default function Subtitle(props) {
	// console.log('Subtitle', props);
	return (
		<h2
			className={
				props.classname ? props.classname : 'mt-4 mb-2 font-weight-bold'
			}
		>
			{props.subtitle}
		</h2>
	);
}
